const initialState = {
  status: "invalid",
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "PAGES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PAGES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
        meta: payload.meta,
      };
    case "PAGES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
